import {AvalancheReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelPartAnimator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {MonkeysGoldGameModuleConfig} from "../MonkeysGoldGameModuleConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../MonkeysGoldSoundConfig";

export class MGReelEvents {
    public static readonly SYMBOL_DROP_COMPLETED:string = "mgReelEvents_symbolDropCompleted";
    public static readonly SYMBOLS_ALL_OUT:string = "mgReelEvents_symbolsAllOut";
}

export class MGReelPartAnimator extends AvalancheReelPartAnimator {

    private _isAvalanche:boolean = false;
    private _playIndividualSymbolSound:boolean;

    constructor(reelId:number) {
        super(reelId);
    }

    public initSymbols(symbols:StateReelSymbol[]):void {
        super.initSymbols(symbols);
        for(let i:number = 0; i < symbols.length; i++) {
            if(symbols[i].symName == "S") {
                MonkeysGoldGameModuleConfig.monkeysGoldScatterLandController.playScatterLandAnimation(symbols[i], -1);
            }
        }
    }

    protected initTargetPositions():void {
        this._targetPositions = [];
        let targetPosition:number;
        const positionsNumTotal:number = GameConfig.instance.SYMBOLS_NUM_IN_REEL[2];
        for(let i:number = 0; i < positionsNumTotal; i++) {
            targetPosition = this.symStep * i + this._symHeight / 2;
            this._targetPositions.push(targetPosition);
        }
    }

    // TODO: there is a risk that the win positions are removed when creating the timeline but the symbolsToAnimate will only be updated when the timeline start.
    // So if there is a duration between the creating and playing, and the timeline is abort, it can be a problem.
    // So when abort happens, always have to check if the progress === 0 then play() and progress(1) before checking the isActive() then pause and kill or progress(1)
    public getAvalancheAnimation(positions:boolean[], allWinPositions:boolean[] | null, delay:number, onSymbolCompleteCallback:(symbol:StateReelSymbol) => void, onSymbolUpgradeCompleteCallback?:(symbol:StateReelSymbol, symName:string, deleteOld:boolean, state?:ISymbolStateConfig) => any):Timeline {
        if(!positions.includes(false)) {
            this.sendCompleteEvent();
            return new TimelineLite();
        }

        const timeline:TimelineLite = new TimelineLite();
        const leftSymbols:StateReelSymbol[] = this._symbolsToAnimate.concat();
        // To remove all win position symbols.
        let i:number = 1;

        while(positions.length > 0) {
            if((leftSymbols.length - i) < 0) {
                break; // if the position is longer than symbols.
            }
            const toRemove:boolean = positions.pop()!;
            if(!toRemove) {
                const symId:number = leftSymbols.length - i;
                const symbol:StateReelSymbol = leftSymbols.splice(symId, 1)[0];
                timeline.add(() => onSymbolCompleteCallback(symbol));
                if(allWinPositions != null) {
                    allWinPositions.splice(allWinPositions.length - i, 1); // Change the winPositions too so it doesn't run it again when zerobet start.
                    allWinPositions.unshift(false);
                }
            } else {
                i++;
            }
        }
        timeline.add(() => {
            this._symbolsToAnimate = leftSymbols.concat()
        }); // Must update the _symbolsToAnimate before new symbols come in.

        // Get symbol avalanche animations.
        for(let i:number = 0; i < leftSymbols.length; i++) {
            const symId:number = leftSymbols.length - 1 - i;
            const positionId:number = this._targetPositions.length - 1 - i;
            const symbol:StateReelSymbol = leftSymbols[symId];
            if(symbol == null) {
                debugger;
                throw new Error(`AvalancheReelPartAnimator.getAvalancheAnimation, symbol at index ${symId} is null!`);
            } else {
                this._isAvalanche = true;
                delay = this.addSymbolInAnimationToTimeline(symbol, timeline, delay, this._targetPositions[positionId], i === 0, false, false, i === (leftSymbols.length - 1));
            }
        }
        timeline.add(() => this.playIndividualSymbolSound = false);
        if(leftSymbols.length === 0) {
            timeline.add(() => this.sendCompleteEvent());
        }
        timeline.add(() => this._currentTimeline = null);
        this._currentTimeline = timeline;
        return timeline;
    }

    protected onSymbolInAttentionPointReached(symbol:StateReelSymbol):void {

    }

    protected addSymbolInAnimationToTimeline(symbol:StateReelSymbol, timeline:Timeline, delay:number, targetPosition:number, firstSymbol:boolean, nearWin:boolean, triggerAttention:boolean, lastSymbol:boolean = false):number {
        if(symbol.stackedSymName!.isStacked && !symbol.visible) {
            return delay; // do not play invisible stacked symbols.
        }

        if(symbol.y === targetPosition) {
            if(lastSymbol) {
                timeline.add(() => this.sendCompleteEvent());
            }
            return delay;
        }

        const distanceFactor:number = MathHelper.roundToDecimals((targetPosition - symbol.y) / GameConfig.instance.REEL_AREA_HEIGHT, 3);
        delay += (nearWin && !this.isQuickStop) ? AvalancheReelPartAnimator._nearWinStopSymbolDelay[this._reelId] : this.stopSymDelay;
        const stopSpeed:number = (nearWin && !this.isQuickStop) ? ReelPartAnimator._nearWinSpinSpeeds[this._reelId] : this.stopSpeed;
        if(symbol.symName == "S" && MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.getIsActiveScatter(symbol)) {
            timeline.add(TweenLite.to(MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.getIsActiveScatter(symbol), stopSpeed * distanceFactor, { // I don't abstract the time out here because we should override the whole animation function.
                ease : this.getDefaultStopEase(),
                yPos : targetPosition,
                onComplete : () => {
                    if(triggerAttention) {
                        this.onSymbolInAttentionPointReached(symbol);
                    } else {
                        if(lastSymbol) {
                            this.sendCompleteEvent();
                        }
                    }
                }
            }), delay);
        }
        timeline.add(TweenLite.to(symbol, stopSpeed * distanceFactor, { // I don't abstract the time out here because we should override the whole animation function.
            ease : this.getDefaultStopEase(),
            y : targetPosition,
            onComplete : () => {
                if(triggerAttention) {
                    this.onSymbolInAttentionPointReached(symbol);
                } else {
                    if(lastSymbol) {
                        this.sendCompleteEvent();
                    }
                }
            }
        }), delay);

        if(symbol.symName.indexOf("colossalx2") > -1 || symbol.symName.indexOf("colossalx3") > -1) {
            timeline.add(() => MonkeysGoldGameModuleConfig.monkeysGoldBigSymbolLandView.playBigSymbolLandAnimation(parseFloat(symbol.symName.slice(symbol.symName.length - 1, symbol.symName.length)), symbol), "-=0.1");
        }

        const unBlurSymbolTimeline:TimelineLite = new TimelineLite({paused : true});
        if(this._isAvalanche == true && this._playIndividualSymbolSound == true) {
            unBlurSymbolTimeline.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.REELS_DEFAULT_BOUNCE[Math.floor(Math.random() * 10)]
            }));
            this._isAvalanche = false;
        }

        unBlurSymbolTimeline.add(symbol.changeState({
            state : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : GameConfig.instance.SYMBOL_STATES.normal,
            replay : false,
            setStack : true,
            fadeInDuration : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION * distanceFactor,
            fadeInDelay : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY * distanceFactor
        }));

        timeline.add(() => unBlurSymbolTimeline.play(), delay);
        //timeline.add(() => {}, delay + unBlurSymbolTimeline.totalDuration());
        if(symbol.symName == "S") {
            //Hide original symbol and play spine scatter animation
            timeline.add(() => MonkeysGoldGameModuleConfig.monkeysGoldScatterLandController.playScatterLandAnimation(symbol, targetPosition), "-=0.05");
        }

        return delay;
    }

    private sendCompleteEvent():void {
        EventHandler.dispatchEvent(new GameEvent(MGReelEvents.SYMBOL_DROP_COMPLETED, this._reelId));
    }

    set playIndividualSymbolSound(value:boolean) {
        this._playIndividualSymbolSound = value;
    }
}